export default { 
  async loadPosts({dispatch, rootGetters}, payload) {
    const wordpresspath = rootGetters.getRootURL
    //console.log(payload)
    if ((payload == 'quienes-somos') || (payload == 'encuentro') || (payload == 'encuentro2024')
        || (payload == 'encuentro2024vivo') || (payload == 'encuentro2024programa')|| (payload == 'encuentro2026')
        || (payload == 'encuentro2026vivo') || (payload == 'encuentro2026programa')
        || (payload == 'encuentro2022') || (payload == 'encuentro-declaraciones') 
        || (payload == 'encuentro-recorrido')  
    ){
      const url = wordpresspath + '/wp-json/wp/v2/pages?slug=' + payload;
      const response = await fetch( url );
      const responseJson = await response.json(); 
      //console.log(url); 
      // console.log(payload);      
      //console.log(responseJson);   
      dispatch('prepararPagina', responseJson)
    // } else if(payload == 'slider-quienes-somos') {
    //   const url = wordpresspath + '/wp-json/wp/v2/sliders/?' + payload + '?per_page=50';  
    //   const response = await fetch( url );
    //   const responseJson = await response.json();  
    //TODO action para llamar slider
    } else {
      const url = wordpresspath + '/wp-json/wp/v2/' + payload + '?per_page=50';      
      const response = await fetch( url );
      const responseJson = await response.json();       
      //console.log(url);
      //console.log(responseJson); 
      if (payload == 'novedades') {
        //console.log('novedades')
        dispatch('prepararNovedades', responseJson)
      } else if (payload == 'definiciones') {
        dispatch('prepararTestimonios', responseJson)
      } else if (payload == 'conceptos') {
        dispatch('prepararConceptos', responseJson)
      } else if (payload == 'espacios') {
        dispatch('prepararEspacios', responseJson)
      } else if (payload == 'articulos') {
        dispatch('prepararArticulos', responseJson)
      } else if (payload == 'proyectos') {
        dispatch('prepararProyectos', responseJson)
      } else if (payload == 'ludiculas') {
        //console.log(responseJson)
        dispatch('prepararLudiculas', responseJson)
      } 
    }   
  },   

  prepararNovedades({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let slug = '';
    let post = {};
    let image = null;
    let contenido = '';
    let resumen = '';
    let destacada = false;
    let orden = '';
    let link = '';
    
    try {
      for (let item of payload) {
        id = item.id;
        nombre = item.title;
        slug = item.slug;
        link = item.meta.aej_novedad_link_alter
        image = item.image_src;
        contenido = item.content.rendered;
        resumen = item.excerpt.rendered;
        if (item.meta.aej_novedad_orden != '') {
          orden = item.meta.aej_novedad_orden;
        } else {
          orden=0
        }

        if (item.meta.aej_novedad_destacada == 1) {
          destacada = true;
        } else {
          destacada = false;
        }
  
        post = {
          id: id,
          nombre: nombre.rendered,
          slug: slug,  
          link: link, 
          image: image, 
          resumen: resumen, 
          contenido: contenido,
          destacada: destacada,
          orden: orden
        };
        //console.log(post)
        postsArray.push(post)
      }
    } catch (error) {
      //console.log(error)
    }

    const posts = {
        tipo: 'novedades',
        posts: postsArray
    }   

    dispatch('updatePosts', posts)
  },   
  prepararTestimonios({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let image = null;
    let post = {};
    let contenido = '';
  
    for (let item of payload) {
      id = item.id;
      nombre = item.title;
      image = item.image_src;
      contenido = item.content.rendered;
      
      post = {
        id: id,
        nombre: nombre.rendered,
        image: image, 
        contenido: contenido,
      };

      postsArray.push(post)
    }

    const posts = {
        tipo: 'testimonios',
        posts: postsArray
    }   
      //console.log(posts)
    dispatch('updatePosts', posts)
  }, 
  prepararConceptos({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let post = {};
    let contenido = '';
    let resumen = '';
  
    for (let item of payload) {
      id = item.id;
      nombre = item.title;
      contenido = item.content.rendered;
      resumen = item.excerpt.rendered;
      
      post = {
        id: id,
        nombre: nombre.rendered,
        contenido: contenido,
        resumen: resumen
      };

      postsArray.push(post)
    }

    const posts = {
        tipo: 'conceptos',
        posts: postsArray
    }   

    dispatch('updatePosts', posts)
  }, 
  prepararEspacios({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let slug = '';
    let post = {};
    let image = null;
    let contenido = '';
    let link = '';

    try {
      for (let item of payload) {
        id = item.id;
        nombre = item.title;
        slug = item.slug;
        image = item.image_src;
        contenido = item.content.rendered;
        link = item.meta.aej_link
  
        post = {
          id: id,
          nombre: nombre.rendered,
          slug: slug,   
          image: image, 
          contenido: contenido,  
          link: link
        };
  
        postsArray.push(post)
      }
    } catch (error) {
      //console.log(error)
    } 

    const posts = {
        tipo: 'espacios',
        posts: postsArray
    } 

    dispatch('updatePosts', posts)
  },   
  prepararPagina({ dispatch }, payload) {
    let id = '';
    let nombre = '';
    let slug = '';
    let page = {};
    let resumen = '';
    let contenido = '';
    let image = null;
    id = payload[0].id;
    nombre = payload[0].title;
    slug = payload[0].slug;
    resumen = payload[0].excerpt.rendered;
    contenido = payload[0].content.rendered;
    image = payload[0].image_src;
      
      page = {
        id: id,
        nombre: nombre.rendered,
        slug: slug,   
        resumen: resumen,
        contenido: contenido,
        image: image
      };
      //console.log(page)
    dispatch('updatePage', page)
  }, 
  prepararArticulos({ dispatch, state }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let subtitulo = '';
    let titulo = '';
    let color = '';
    let proyecto = '';
    let header = '';
    let proyectoTitulo = '';
    let slug = '';
    let post = {};
    let image = null;
    let contenido = '';
    let resumen = '';
    
    let proyectos = state.proyectos;
    //console.log(payload);
    //console.log(proyectos);
    for (let item of payload) {
      id = item.id;
      nombre = item.title;
      proyectoTitulo = (item.meta.aej_articulo_proyecto_titulo == 1) ? true : false;
      subtitulo = item.meta.aej_articulo_subtitulo;
      color = item.meta.aej_articulo_header_color;
      if (item.meta.aej_articulo_proyecto){
        //console.log(item.meta.aej_articulo_proyecto)
        proyectos.forEach(p => {
          if (p.id == item.meta.aej_articulo_proyecto){
            proyecto = p.nombre;
            //console.log(proyecto)
          } else {
            //console.log('no coincide')
          }
        });
      } else {
        proyecto = false;
      }
      titulo = item.meta.aej_articulo_proyecto_titulo && proyecto  ? proyecto : (item.meta.aej_articulo_titulo ? item.meta.aej_articulo_titulo : item.title.rendered);
      header = (item.meta.aej_articulo_header == 1) ? true : false;
      slug = item.slug;
      image = item.image_src;
      contenido = item.content.rendered;
      resumen = item.excerpt.rendered;

      post = {
        id: id,
        nombre: nombre.rendered,
        proyectoTitulo: proyectoTitulo,
        slug: slug,   
        image: image, 
        resumen: resumen, 
        contenido: contenido,
        titulo: titulo,  
        subtitulo: subtitulo,  
        color: color,  
        proyecto: proyecto,  
        header: header
      };
      postsArray.push(post)
    }

    const posts = {
        tipo: 'articulos',
        posts: postsArray
    }   
    //console.log(posts)

    dispatch('updatePosts', posts)
  },
  prepararProyectos({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let slug = '';
    let post = {};
    let image = null;
    let color = '';
    let contenido = '';
    let subtitulo = '';
    let optionalLink = '';
    let orden = '';

    try {
      for (let item of payload) {
        id = item.id;
        nombre = item.title;
        slug = item.slug;
        image = item.image_src;
        color = item.meta.aej_proyecto_color;
        contenido = item.content.rendered;
        subtitulo = item.meta.aej_proyecto_subtitulo;
        optionalLink = item.meta.aej_proyecto_optionallink;

        if (item.meta.aej_proyecto_orden != '') {
          orden = item.meta.aej_proyecto_orden;
        } else {
          orden=0
        }
  
        post = {
          id: id,
          nombre: nombre.rendered,
          slug: slug,   
          image: image, 
          color: color,  
          contenido: contenido,  
          subtitulo: subtitulo, 
          orden: orden,
          link: optionalLink
        };
        //console.log(post)
        postsArray.push(post)
      }
    } catch (error) {
      console.log(error)
    }

    const posts = {
        tipo: 'proyectos',
        posts: postsArray
    } 
    //console.log(posts)
    dispatch('updatePosts', posts)
  },     
  prepararSliders({ dispatch }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let slug = '';
    let post = {};

    try {
      for (let item of payload) {
        id = item.id;
        nombre = item.title;
        slug = item.slug;
  
        post = {
          id: id,
          nombre: nombre.rendered,
          slug: slug,   
        };
        //console.log(post)
        postsArray.push(post)
      }
    } catch (error) {
      console.log(error)
    }

    const posts = {
        tipo: 'proyectos',
        posts: postsArray
    } 
    //console.log(posts)
    dispatch('updatePosts', posts)
  },    
  prepararLudiculas({ dispatch, getters }, payload) {
    const postsArray = [];
    let id = '';
    let nombre = '';
    let slug = '';
    let post = {};
    let image = null;
    let video = null;
    let contenido = '';
    let resumen = '';
    let NombresID = [];
    let categorias = [];
    let tags = [];
    let otrosNombres = [];
    let curiosidades = "";
    let desarrollo = "";
    // let disposicion = "";
    let fuente = "";
    // let invitacion = "";
    // let sistema = "";
    let sugerencias = "";
    let variantes = "";
    
    try {
      for (let item of payload) {
        id = item.id;
        nombre = item.title;
        slug = item.slug;
        image = item.image_src;
        video = item.meta.aej_ludicula_video_link;
        contenido = item.content.rendered;
        resumen = item.excerpt.rendered;
        categorias = item['categorias-primarias'];
        tags = item['categorias-secundarias'];
        NombresID = item['otros-nombres'];
        otrosNombres =[];
        // otrosNombres = item.meta.aej_ludicula_otros_nombres;      
        curiosidades = item.meta.aej_ludicula_curiosidades;        
        desarrollo = item.meta.aej_ludicula_desarrollo; 
        // disposicion = item.meta.aej_ludicula_disposicion_inicial; 
        fuente = item.meta.aej_ludicula_fuente; 
        // invitacion = item.meta.aej_ludicula_invitacion; 
        // sistema = item.meta.aej_ludicula_sistema; 
        sugerencias = item.meta.aej_ludicula_sugerencias; 
        variantes = item.meta.aej_ludicula_variantes; 

        //console.log(NombresID)

        if (NombresID) {
          //console.log(NombresID)
          for (id of NombresID) {
          //  console.log(nombre)
            otrosNombres.push(getters.getNombre(id)); 
          }
        }

       // console.log(otrosNombres)
  //FIXME: ver como era para cargar un video
        post = {
          id: id,
          nombre: nombre.rendered,
          slug: slug,   
          image: image, 
          video: video,
          resumen: resumen, 
          contenido: contenido,
          categorias: categorias,
          tags: tags,
          otrosNombres: otrosNombres,
          curiosidades: curiosidades,
          desarrollo: desarrollo,
          // disposicion: disposicion,
          fuente: fuente,
          // invitacion: invitacion,
          // sistema: sistema,
          sugerencias: sugerencias,
          variantes: variantes
        };
        // console.log(post)
        postsArray.push(post)
      }
    } catch (error) {
      console.log(error)
    }

    const posts = {
        tipo: 'ludiculas',
        posts: postsArray
    }   
    //console.log(posts)  
    dispatch('updatePosts', posts)
  },  
  updatePosts(context, payload) {
    context.commit('updatePosts', payload);
  },

  updatePage(context, payload) {
    //console.log( payload)
    context.commit('updatePage', payload);
  },

  async loadCategorias({dispatch, rootGetters}) {
    const wordpresspath = rootGetters.getRootURL
   // console.log(wordpresspath);
    const url = wordpresspath + '/wp-json/wp/v2/categorias-primarias?per_page=50';    
    //console.log(url);
    const response = await fetch( url );
    const responseJson = await response.json();       
    //console.log(responseJson); 
      dispatch('prepararCategoriasPrimarias', responseJson)
  },  

  async loadTags({dispatch, rootGetters}) {
    const wordpresspath = rootGetters.getRootURL
   // console.log(wordpresspath);
    const url = wordpresspath + '/wp-json/wp/v2/categorias-secundarias?per_page=50';  
    //console.log(url);
    const response = await fetch( url );
    const responseJson = await response.json();       
    //console.log(responseJson); 
      dispatch('prepararCategoriasSecundarias', responseJson)
  },  

  async loadOtrosNombres({dispatch, rootGetters}) {
    const wordpresspath = rootGetters.getRootURL
   // console.log(wordpresspath);
    const url = wordpresspath + '/wp-json/wp/v2/otros-nombres?per_page=50';  
    //console.log(url);
    const response = await fetch( url );
    const responseJson = await response.json();       
    //console.log(responseJson); 
      dispatch('prepararOtrosNombres', responseJson)
  },  

  prepararCategoriasPrimarias({ dispatch }, payload) {
    const categoriasArray = [];
    let id = '';
    let nombre = '';
    let thumbnail = null;
    let icono = '';
    let slug = '';
    let parent = '';
    let categoria = {};
    
    for (let item of payload) {
      id = item.id;
      nombre = item.name;
      slug = item.slug;
      thumbnail = item.image_src;
      icono = item.meta.aej_categoria_icono;

      if (item.parent == 0){
        parent = 'padre';
      } else {
        parent = item.parent;
      }
      categoria = {
        id: id,
        nombre: nombre,
        slug: slug,   
        icono: icono,
        thumbnail: thumbnail, 
        parent: parent,
      };
      //console.log(categoria)
      categoriasArray.push(categoria)
    }

    const categorias = {
        tipo: 'ludiculas-categorias',
        categorias: categoriasArray
    }       
    dispatch('updateCategorias', categorias)
  },  

  prepararCategoriasSecundarias({ dispatch }, payload) {
    const categoriasArray = [];
    let id = '';
    let nombre = '';
    let thumbnail = null;
    let icono = '';
    let slug = '';
    let parent = '';
    let categoria = {};
    
    for (let item of payload) {
      id = item.id;
      nombre = item.name;
      slug = item.slug;
      thumbnail = item.image_src;
      icono = item.meta.aej_categoria_icono;

      if (item.parent == 0){
        parent = 'padre';
      } else {
        parent = item.parent;
      }
      categoria = {
        id: id,
        nombre: nombre,
        slug: slug,   
        icono: icono,
        thumbnail: thumbnail, 
        parent: parent,
      };
      //console.log('informe')
      //console.log(categoria)
      categoriasArray.push(categoria)
    }

    const categorias = {
        tipo: 'ludiculas-tags',
        categorias: categoriasArray
    }       
    dispatch('updateCategorias', categorias)
  },  
  

  prepararOtrosNombres({ dispatch }, payload) {
    const nombresArray = [];
    let id = '';
    let nombre = '';
    let categoria = {};
    
    for (let item of payload) {
      id = item.id;
      nombre = item.name;

      categoria = {
        id: id,
        nombre: nombre,
      };

      nombresArray.push(categoria)
    }
    
    const categorias = {
        tipo: 'nombres-tags',
        categorias: nombresArray
    }       
    dispatch('updateCategorias', categorias)
  },  



  updateCategorias(context, payload) {
    context.commit('updateCategorias', payload);
  },

  async actualizarFiltros( { dispatch } , payload ){
    //Determinar si agregar o eliminar el filtro, según si está o no en el array de filtros
    //console.log(payload);
    let filtrosActualizar = {};
    if (payload != 'delete'){
      let filtrosCat = payload.todos;
      let filtro = payload.filtro.itemID;
      filtrosActualizar.tipo = payload.filtro.tipo
      filtrosActualizar.filtros = [];
      //console.log(filtrosCat)
      if (filtrosCat){
        //console.log(filtrosCat);
        if (filtrosCat.find((id) => id == filtro)) { //ya está => lo elimino        
          filtrosActualizar.filtros = filtrosCat.filter((id) => id != filtro)
        } else { //no ya está => lo agrego
          filtrosActualizar.filtros = filtrosCat
          filtrosActualizar.filtros.push(filtro)
        }
      } else { //primer filtro
        //console.log('primer filtro');
        filtrosActualizar.filtros.push(filtro)
      }
    }

    //console.log(filtrosActualizar)
    dispatch('updateFiltros', filtrosActualizar) 
  },

  updateFiltros(context, payload) {
    context.commit('updateFiltros', payload);
  }, 

}